import axios from 'axios'
import React, { useEffect, useState } from 'react'
import TreeItem from './TreeItem'

const server = process.env.REACT_APP_SERVER_URL
const AccountingPlanBody: React.FC<IAccountingPlan> = ({
  columns,
  childrenOf,
}) => {
  const [accountingPlan, setAccountingPlan] = useState([])

  //   const [isOpen, setIsOpen] = useState(false)

  // const [idOpen, setIdOpen] = useState<any[]>([])

  const onGetAccountingPlan = async (): Promise<void> => {
    let response = await axios.get(
      `${server}/accounting?childrenOf=${childrenOf}`
    )
    // console.log('response...', response)
    setAccountingPlan(response.data.accounts.sort((a, b) => +a.code - +b.code))
  }

  useEffect(() => {
    onGetAccountingPlan()
    // console.log("llega...", idOpen)
  }, [])

  // useEffect(() => {
  //   console.log('idopen...', idOpen)
  // }, [idOpen])

  const checkIfOpen = (id) => {
    // return idOpen.some((v) => v === id)
  }

  const createTree = (branch) => {
    // return (
    //   <TreeItem branch={branch}>
    //     {branch?.children?.map((row) => {
    //       return createTree(row)
    //     })}
    //   </TreeItem>
    // )
  }

  return (
    <div>
      { accountingPlan.map(v => (
        <TreeItem accountingPlan={v} columns={columns} />
      )) }
    </div>
  )
}

interface IAccountingPlan {
  columns: any[]
  childrenOf: string
}

export default AccountingPlanBody
